import { render, staticRenderFns } from "./FormSituacaoAtendimento.vue?vue&type=template&id=abaf5742"
import script from "./FormSituacaoAtendimento.vue?vue&type=script&lang=js"
export * from "./FormSituacaoAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports